import { HttpClient} from "@angular/common/http";
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

import { environment } from '../../../environments/environment';

@Injectable()
export class StudyService {

    constructor(private http: HttpClient) {}

    all(req){
        req.activeSort = req.activeSort || 'id';
        req.sortDirection = req.sortDirection || 'asc';
        req.page = req.page || 1; //default first page
        req.perPage = req.perPage || 5; //default no limit
        req.filter = req.filter || '';
        req.trash = req.trash || '';

        let requestUrl = environment.apiUrl + 'work/study/all';
        requestUrl += "?page=" + req.page + "&perPage=" + req.perPage + "&activeSort=" + req.activeSort + "&sortDirection=" + req.sortDirection + "&filter=" + req.filter + "&trash=" + req.trash;
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    add(branch){
        let requestUrl = environment.apiUrl + 'work/study/store';
        return this.http.post(requestUrl, branch).map( (res: any) => {
            return res;
        });
    }

    edit(branch){
        let requestUrl = environment.apiUrl + 'work/study/update/' + branch.id;
        return this.http.put(requestUrl, branch).map( (res: any) => {
            return res;
        });
    }

    get(id){
        let requestUrl = environment.apiUrl + 'work/study/get/' + id;
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    getResult(id){
        let requestUrl = environment.apiUrl + 'work/study/getResult/' + id;
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    saveResult(id, results){
        let requestUrl = environment.apiUrl + 'work/study/updateResult/' + id;
        return this.http.post(requestUrl, {results: results}).map( (res: any) => {
            return res;
        });
    }

    getRequirements(id){
        let requestUrl = environment.apiUrl + 'work/study/getRequirements/' + id;
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    saveRequirements(id, requirements){
        let requestUrl = environment.apiUrl + 'work/study/updateRequirements/' + id;
        return this.http.post(requestUrl, {requirements: requirements}).map( (res: any) => {
            return res;
        });
    }


    restore(id){
        let requestUrl = environment.apiUrl + 'work/study/restore/' + id;
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    delete(id){
        let requestUrl = environment.apiUrl + 'work/study/delete/' + id;
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

}



// WEBPACK FOOTER //
// /Users/cricketmon/Sites/clubsandwichadmin/src/app/shared/services/study.service.ts